import { useRef, useEffect } from 'react'
import styles from './ChatInput.module.scss'

export const ChatInput = ({ value, onChange, onKeyPress, disabled, placeholder }) => {
    const textareaRef = useRef(null)

    // Auto-resize textarea based on content
    useEffect(() => {
        if (textareaRef.current) {
            // Reset height to auto to get the correct scrollHeight
            textareaRef.current.style.height = 'auto'
            // Set height to scrollHeight, with min and max constraints
            const newHeight = Math.min(Math.max(textareaRef.current.scrollHeight, 20), 80) // min 1 line (~20px), max ~3 lines
            textareaRef.current.style.height = `${newHeight}px`
        }
    }, [value])

    return (
        <div className={styles.container}>
            <textarea
                ref={textareaRef}
                value={value}
                onChange={onChange}
                onKeyDown={onKeyPress}
                disabled={disabled}
                placeholder={placeholder}
                className={styles.textarea}
                rows={1}
            />
        </div>
    )
}
